import { Priority, PriorityType } from "../../../../types/block/enum";
import PriorityIcon from "../../../atom/icons/PriorityIcon";

const PRIORITY_COLOR = {
  [Priority.DEFAULT]: "#cacdce",
  [Priority.HIGH]: "#FF6D6D",
  [Priority.MEDIUM]: "#FFB65F",
  [Priority.LOW]: "#4BC37B",
};

const CurrentPriorityIcon = ({
  priority,
  color,
  className,
}: {
  priority: PriorityType;
  color?: string;
  className?: string;
}) => {
  return (
    <PriorityIcon
      color={color ?? PRIORITY_COLOR[priority]}
      className={className}
    />
  );
};

export default CurrentPriorityIcon;
